import { render } from "./UploadFileList.vue?vue&type=template&id=231aa3c0&scoped=true"
import script from "./UploadFileList.vue?vue&type=script&lang=ts"
export * from "./UploadFileList.vue?vue&type=script&lang=ts"

import "./UploadFileList.vue?vue&type=style&index=0&id=231aa3c0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-231aa3c0"

export default script